//React
import { useState } from "react";

// MUI
import { GridApiPremium } from "@mui/x-data-grid-premium/models/gridApiPremium";
import { GridRenderCellParams, GridTreeNodeWithRender } from "@mui/x-data-grid-pro";

// Third Party
import clsx from "clsx";

// Components
import TypographyCell from "@/Layouts/components/Tables/DataSmartTable/additional/TypographyCell";
import NotesDialog from "./NotesDialog";

// Helpers
import { or } from "@/Common/helpers/sonar";

// Types
import { IReconciliationNote, IReconciliationNoteHistory } from "@/DataPages/types/inventory/models/reconciliation";

const getText = (value: IReconciliationNote | undefined) => {
	const hasNotes = value?.notes?.some((noteHistory) => !!noteHistory.note);
	if (hasNotes) {
		return "View Notes";
	} else {
		return "No Notes";
	}
};

const buildTitle = (params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>) => {
	const { row } = params;
	return `${row.vehicle.year} ${row.vehicle.make} ${row.vehicle.model} - VIN# ${row.vehicle.vinNumber}`;
};

interface IEditCellDialogProps {
	editable: boolean;
	apiRef: React.MutableRefObject<GridApiPremium>;
	params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>;
	onChangePopupVisibility: (isOpen: boolean) => void;
}

const EditCellDialog = (props: IEditCellDialogProps) => {
	const { editable, apiRef, params, onChangePopupVisibility } = props;
	const { id, value } = params;
	const [isOpen, setIsOpen] = useState(false);

	const handleOpenNotes = () => {
		if (!editable && !value?.notes.some((noteHistory: IReconciliationNoteHistory) => !!noteHistory.note)) {
			return;
		}
		setIsOpen(true);
		onChangePopupVisibility(true);
	};

	const handleClosedNotes = () => {
		setIsOpen(false);
		onChangePopupVisibility(false);
		if (!editable) {
			return;
		}
	};

	const shouldBeEnabled = or(
		editable,
		value?.notes?.some((noteHistory: IReconciliationNoteHistory) => !!noteHistory.note)
	);

	return (
		<>
			<TypographyCell
				className={clsx("!text-default decoration-primary", {
					"!text-primary": shouldBeEnabled,
					"underline cursor-pointer": shouldBeEnabled,
				})}
				fontLineHeight="24px"
				hasTooltip={false}
				onClick={handleOpenNotes}
			>
				{getText(value)}
			</TypographyCell>
			<NotesDialog
				isOpen={isOpen}
				onCloseNotesDialog={handleClosedNotes}
				id={id.toString()}
				title={buildTitle(params)}
				params={params}
				apiRef={apiRef}
				editable={editable}
			/>
		</>
	);
};

export default EditCellDialog;
